/**
 * OrderDashboardPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col } from 'components';
import { Divider, Table, Spin, Statistic } from 'antd';
import {
  CartesianGrid,
  Tooltip,
  BarChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Legend,
  Bar,
  Rectangle,
} from 'recharts';
import { stringToMoneyFormat } from 'utils';
import OrderStatus from 'routes/admin.routes/admin.dashboard/HomeDashboard/components/OrderStatus';
import moment from 'moment';
import dayjs from 'dayjs';

/**----------------------------------------
 * [Component] 총관리자: 주문대시보드 - 프레젠터
 * ----------------------------------------
 */
const OrderDashboardPresenter = ({
  loading,
  // chartData,
  // statisticsType,
  // setStatisticsType,
  orderList,
  // handleGetCartList,
  startDate,
  endDate,
}) => {
  const {
    totalAmountMonth,
    netsAmountMonth,
    refundAmountMonth,
    totalAmountDay,
    netsAmountDay,
    refundAmountDay,
    newOrderList,
  } = React.useMemo(() => {
    const { parcelSale, refundSale } = orderList;
    // 총매출
    const totalAmountMonth = !parcelSale
      ? 0
      : parcelSale.reduce(
        (acc, cur) =>
          acc +
          Number(cur.totalAmount ?? 0) +
          Number(cur.totalDeliveryAmount ?? 0) +
          Math.abs(Number(cur.totalUsePointAmount ?? 0)),
        0
      );
    // 순매출
    const netsAmountMonth = !parcelSale
      ? 0
      : parcelSale.reduce(
        (acc, cur) =>
          acc + Number(cur.netsAmount ?? 0) + Number(cur.deliveryAmount ?? 0),
        0
      );
    // 환불
    const refundAmountMonth = !refundSale
      ? 0
      : refundSale.reduce((acc, cur) => acc + Number(cur.refundAmount ?? 0), 0);
    //하위 통계 (오늘)
    const today = moment().format('YYYY-MM-DD');
    const todaySale = parcelSale.find((item) => item.date === today);
    const todayRefund = refundSale.find((item) => item.date === today);
    const deliveryAmountDay = Number(todaySale?.deliveryAmount ?? 0);
    //오늘 실 결제 금액
    const netsAmountDay = todaySale
      ? Number(todaySale.netsAmount) + deliveryAmountDay
      : 0;
    //오늘 환불 금액
    const refundAmountDay = Number(todayRefund?.refundAmount ?? 0);
    //오늘 총 매출
    const totalUsePointAmountDay = Math.abs(
      Number(todaySale?.totalUsePointAmount ?? 0)
    );
    const totalAmountDay = todaySale
      ? Number(todaySale.totalAmount) +
      Number(todaySale.totalDeliveryAmount) +
      totalUsePointAmountDay
      : 0;

    return {
      totalAmountMonth,
      netsAmountMonth,
      refundAmountMonth,
      totalAmountDay: totalAmountDay,
      netsAmountDay,
      refundAmountDay,
      newOrderList: {
        refundSale,
        parcelSale: parcelSale.sort((a, b) => dayjs(b.date) - dayjs(a.date)),
      },
    };
  }, [orderList]);
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */

  /* ===== VARIABLE ===== */
  // const formItem = [
  //   {
  //     label: '검색',
  //     form: [
  //       {
  //         input: (
  //           <div style={{ width: '100%' }}>
  //             <Select
  //               size="large"
  //               defaultValue="lucy"
  //               style={{
  //                 width: 140,
  //                 marginRight: 4,
  //               }}
  //               // onChange={handleChange}
  //               options={[
  //                 {
  //                   value: 'jack',
  //                   label: 'Jack',
  //                 },
  //                 {
  //                   value: 'lucy',
  //                   label: 'Lucy',
  //                 },
  //                 {
  //                   value: 'Yiminghe',
  //                   label: 'yiminghe',
  //                 },
  //                 {
  //                   value: 'disabled',
  //                   label: 'Disabled',
  //                   disabled: true,
  //                 },
  //               ]}
  //             />
  //             <Input
  //               size="large"
  //               style={{ width: 350 }}
  //               placeholder="주문번호를 입력해주세요"
  //             />
  //           </div>
  //         ),
  //       },
  //     ],
  //   },
  // ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */

  /*  */
  /* 상품별 데이터 */

  /* ===== RENDER ===== */
  // JSX: start
  return (
    <Spin spinning={loading}>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title
              size={3}
              style={{ marginBottom: 12 }}
              subButton={
                <>
                  <span
                    style={{
                      fontWeight: '400',
                      fontSize: '0.75em',
                      opacity: 0.7,
                    }}
                  >
                    조회기간: {startDate} ~ {endDate}
                  </span>
                </>
              }
            >
              쇼핑몰관리 홈(대시보드)
            </Title>

            {/* 검색필터 */}
            {/* <Content
              maxWidth={'100%'}
              padding={0}
              // backgroundColor={'none'}
              style={{ marginBottom: 5 }}
            >
              <Row>
                <Col x={19}>
                  <ExpandableContainer borderRadius={4} padding={20}>
                    {formItem.map((_item, _index) => (
                      <div
                        key={`form_${_index}`}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '10px 0px',
                        }}
                      >
                        <div
                          style={{ width: 90, fontSize: 13, fontWeight: 400 }}
                        >
                          <label>{_item.label}</label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          {_item.form.map((_subitem, _subkey) => (
                            <React.Fragment key={`input_${_subkey}`}>
                              {_subitem.input}
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                    ))}
                  </ExpandableContainer>
                </Col>
                <Col
                  x={5}
                  style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                  }}
                >
                  <Button
                    size="large"
                    type="primary"
                    onClick={() => handleGetCartList()}
                  >
                    <SearchOutlined /> 검색
                  </Button>
                  &nbsp;
                  <Button
                    size="large"
                    // onClick={handleResetFilter}
                  >
                    <ReloadOutlined /> 초기화
                  </Button>
                </Col>
              </Row>
            </Content> */}
            {/* 검색필터 끝 */}

            {/* === 현황 요약: start === */}
            <Content
              fullWidth
              padding={0}
              backgroundColor={'none'}
              style={{
                marginBottom: 5,
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              {[
                {
                  title: '이번달 총 주문금액',
                  value: stringToMoneyFormat(totalAmountMonth ?? 0),
                  suffix: '원',
                },
                {
                  title: '이번달 실 결제금액',
                  value: stringToMoneyFormat(netsAmountMonth ?? 0),
                  suffix: '원',
                },
                {
                  title: '이번달 환불금액',
                  value: stringToMoneyFormat(refundAmountMonth ?? 0),
                  suffix: '원',
                },
              ].map((_item, _index) => (
                <div
                  key={`${_item.label}-${_index}`}
                  className="boxShadow"
                  style={{
                    background: '#FFFFFF',
                    borderRadius: 4,
                    width: `90%`,
                    margin: '0 2px',
                    padding: '15px 24px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  {/* <MyStatistic */}
                  <Statistic
                    className="cursorOverOpacity"
                    direction={'row'}
                    size="large"
                    title={_item.title}
                    value={_item.value}
                    suffix={_item.suffix}
                    valueStyle={{
                      color: '#EB2F96',
                      // textAlign: 'center',
                      fontSize: '1.55em',
                    }}
                  />
                </div>
              ))}
            </Content>
            {/* === 현황 요약: end === */}
            {/* === 현황 요약: start === */}

            <Content
              fullWidth
              padding={0}
              backgroundColor={'none'}
              style={{
                marginBottom: 5,
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              {[
                {
                  title: '오늘 총 주문금액',
                  value: stringToMoneyFormat(totalAmountDay ?? 0),
                  suffix: '원',
                },
                {
                  title: '오늘 실 결제금액',
                  value: stringToMoneyFormat(netsAmountDay ?? 0),
                  suffix: '원',
                },
                {
                  title: '오늘 환불금액',
                  value: stringToMoneyFormat(refundAmountDay ?? 0),
                  suffix: '원',
                },
              ].map((_item, _index) => (
                <div
                  key={`${_item.label}-${_index}`}
                  className="boxShadow"
                  style={{
                    background: '#FFFFFF',
                    borderRadius: 4,
                    width: `90%`,
                    margin: '0 2px',
                    padding: '15px 24px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  {/* <MyStatistic */}
                  <Statistic
                    className="cursorOverOpacity"
                    direction={'row'}
                    size="large"
                    title={_item.title}
                    value={_item.value}
                    suffix={_item.suffix}
                    valueStyle={{
                      color: '#1677ff',
                      // textAlign: 'center',
                      fontSize: '2.15em',
                    }}
                  />
                </div>
              ))}
            </Content>
            {/* === 현황 요약: end === */}

            {/* === 현황 요약: start === */}
            <Title size={5} style={{ margin: '14px 0 8px' }}>
              오늘 주문 현황
            </Title>
            <OrderStatus
              loading={loading}
              data={
                newOrderList?.parcelSale ? newOrderList?.parcelSale : null
              }
            />
            {/* === 현황 요약: end === */}

            {/* ===== 차트: start ===== */}
            <Row gutter={[5, 5]}>
              {/* === 상품별: start === */}
              <Col x={11}>
                <Content
                  maxWidth={'100%'}
                  borderRadius={4}
                  // padding={'14px 5px'}
                  height={470}
                >
                  <Title size={5} style={{ marginBottom: 12 }}>
                    일별 매출현황
                  </Title>
                  <Divider style={{ margin: 0 }} />
                  <ResponsiveContainer
                    width="100%"
                    height={375}
                    style={{ marginTop: 25 }}
                  >
                    <BarChart
                      width={500}
                      // height={300}
                      data={
                        !newOrderList?.parcelSale
                          ? []
                          : newOrderList?.parcelSale
                            ?.slice(0, 10)
                            .map((item) => ({
                              ...item,
                              date: moment(item.date).format('MM/DD'),
                              ['총매출']:
                                Number(item.totalAmount ?? 0) +
                                Number(item.totalDeliveryAmount ?? 0) +
                                Math.abs(Number(item.totalUsePointAmount)),
                              ['순매출']:
                                Number(item.netsAmount ?? 0) +
                                Number(item.deliveryAmount ?? 0),
                            }))
                      }
                      margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <YAxis dataKey="총매출" />
                      <XAxis dataKey="date" />
                      <Tooltip />
                      <Legend />
                      <Bar
                        dataKey="총매출"
                        fill="#8884d8"
                        activeBar={<Rectangle fill="pink" stroke="blue" />}
                      />
                      <Bar
                        dataKey="순매출"
                        fill="#82ca9d"
                        activeBar={<Rectangle fill="gold" stroke="purple" />}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </Content>
              </Col>
              {/* === 상품별: end === */}

              {/* === 내역: start === */}
              <Col x={13}>
                <Content
                  maxWidth={'100%'}
                  height={470}
                  borderRadius={4}
                // padding={'14px 5px'}
                >
                  <Title size={5} style={{ marginBottom: 12 }}>
                    일별 주문내역
                  </Title>

                  {/* <Table
                    bordered
                    // size="small"
                    scroll={{ x: 650, y: 450 }}
                    pagination={false}
                    dataSource={
                      productChart
                        .sort((a, b) => a.value - b.value)
                        .reverse() ?? []
                    }
                    columns={[
                      {
                        title: '날짜',
                        dataIndex: 'created_at',
                        width: 150,
                        align: 'center',
                      },
                      {
                        title: '주문건수',
                        dataIndex: 'value',
                        width: 120,
                        align: 'center',
                        render: (value) => `${stringToMoneyFormat(value)}`,
                      },
                      {
                        title: '주문금액',
                        dataIndex: 'price',
                        width: 150,
                        align: 'center',
                        render: (value) => `${stringToMoneyFormat(value)}원`,
                      },
                      {
                        title: '환불금액',
                        dataIndex: 'price',
                        width: 150,
                        align: 'center',
                        render: (value) => `${stringToMoneyFormat(value)}원`,
                      },
                    ]}
                  /> */}
                  <Table
                    bordered
                    size="small"
                    scroll={{ x: 650, y: 400 }}
                    pagination={false}
                    dataSource={newOrderList?.parcelSale ?? []}
                    style={{ borderBottom: '1px solid #f1f1f1' }}
                    columns={[
                      {
                        title: '날짜',
                        dataIndex: 'date',
                        width: 100,
                        align: 'center',
                        fixed: 'left',
                        // render: (v) => moment(v).format('YYYY-MM-DD'),
                      },
                      {
                        title: '총매출',
                        dataIndex: 'totalAmount',
                        width: 100,
                        align: 'center',
                        render: (value, record) =>
                          `${stringToMoneyFormat(
                            Number(value) +
                            Number(record.totalDeliveryAmount) +
                            Math.abs(Number(record.totalUsePointAmount))
                          )}원`,
                      },
                      {
                        title: '순매출',
                        dataIndex: 'netsAmount',
                        width: 100,
                        align: 'center',
                        render: (value, record) =>
                          `${stringToMoneyFormat(
                            Number(value) + Number(record.deliveryAmount) + Number(record.discountAmount)
                          )}원`,
                      },
                      {
                        title: '주문/환불건수',
                        dataIndex: 'paymentCount',
                        width: 100,
                        align: 'center',
                        render: (value, record) =>
                          `${stringToMoneyFormat(
                            Number(value) + Number(record.refundCount ?? 0)
                          )}건`,
                      },
                      {
                        title: '할인금액',
                        dataIndex: 'discountAmount',
                        width: 100,
                        align: 'center',
                        render: (value) =>
                          `${stringToMoneyFormat(Number(value))}원`,
                      },
                      {
                        title: '환불금액',
                        dataIndex: 'refundAmount',
                        width: 100,
                        align: 'center',
                        render: (value) =>
                          `${stringToMoneyFormat(Number(value))}원`,
                      },
                    ]}
                    summary={(row) => {
                      const totalAmount = row.reduce(
                        (acc, cur) => acc + Number(cur.totalAmount) + Number(cur.totalDeliveryAmount),
                        0
                      );
                      const netsAmount = row.reduce(
                        (acc, cur) => acc + Number(cur.netsAmount) + Number(cur.deliveryAmount) + Number(cur.discountAmount),
                        0
                      );
                      const paymentCount = row.reduce(
                        (acc, cur) => acc + Number(cur.paymentCount),
                        0
                      );
                      const refundCount = row.reduce(
                        (acc, cur) => acc + Number(cur.refundCount ?? 0),
                        0
                      );
                      const discountAmount = row.reduce(
                        (acc, cur) => acc + Number(cur.discountAmount),
                        0
                      );
                      const refundAmount = row.reduce(
                        (acc, cur) => acc + Number(cur.refundAmount ?? 0),
                        0
                      );
                      return (
                        <Table.Summary fixed>
                          <Table.Summary.Row align="center">
                            <Table.Summary.Cell index={0}>
                              <b>합계</b>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1}>
                              <b>{stringToMoneyFormat(totalAmount)}</b>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2}>
                              <b>{stringToMoneyFormat(netsAmount)}</b>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={3}>
                              <b>
                                {stringToMoneyFormat(
                                  Number(paymentCount) + Number(refundCount)
                                )}
                              </b>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={4}>
                              <b>{stringToMoneyFormat(discountAmount)}</b>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={4}>
                              <b>{stringToMoneyFormat(refundAmount)}</b>
                            </Table.Summary.Cell>
                          </Table.Summary.Row>
                        </Table.Summary>
                      );
                    }}
                  />
                </Content>
              </Col>
              {/* === 내역: end === */}
            </Row>
            {/* ===== 차트: end ===== */}
          </Col>
        </Row>
      </Content>
    </Spin>
  ); // JSX: end
};

export default OrderDashboardPresenter;
